// src/components/alerts/BulkAlertActionBar.js
// --- UPDATE (Alert System AI) — NEW: appears when alerts are ticked; acknowledge / resolve them
// in one request, with an optional note that is stamped onto every alert.
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Flex, HStack, Input, useColorModeValue } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { MdCheckCircle, MdEditNote, MdClose } from 'react-icons/md';

const MotionFlex = motion(Flex);

function BulkAlertActionBar({ count, onAcknowledge, onResolve, onClear, isWorking }) {
    const [note, setNote] = useState('');
    const bg = useColorModeValue('blue.50', 'blue.900');
    const border = useColorModeValue('blue.200', 'blue.700');
    const run = async (fn) => { const ok = await fn(note.trim() || undefined); if (ok !== false) setNote(''); };
    return (
        <AnimatePresence>
            {count > 0 && (
                <MotionFlex initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
                    mb={3} p={3} bg={bg} borderWidth="1px" borderColor={border} borderRadius="xl" align="center" gap={3} flexWrap="wrap">
                    <Badge colorScheme="blue" fontSize="sm" px={3} py={1} borderRadius="full">{count} selected</Badge>
                    <Input size="sm" flex="1" minW="200px" placeholder="Optional note for all selected (e.g. crew dispatched)" value={note} onChange={e => setNote(e.target.value)} maxLength={500} bg="white" _dark={{ bg: 'gray.800' }} borderRadius="md" />
                    <HStack>
                        <Button size="sm" colorScheme="blue" leftIcon={<MdEditNote />} onClick={() => run(onAcknowledge)} isLoading={isWorking}>Acknowledge</Button>
                        <Button size="sm" colorScheme="green" leftIcon={<MdCheckCircle />} onClick={() => run(onResolve)} isLoading={isWorking}>Resolve</Button>
                        <Button size="sm" variant="ghost" leftIcon={<MdClose />} onClick={onClear}>Clear</Button>
                    </HStack>
                </MotionFlex>
            )}
        </AnimatePresence>
    );
}

BulkAlertActionBar.propTypes = {
    count: PropTypes.number.isRequired,
    onAcknowledge: PropTypes.func.isRequired,
    onResolve: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    isWorking: PropTypes.bool,
};

export default BulkAlertActionBar;
// --- END UPDATE
